module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_01_black-e2d7aff7105064aa4031606cea343dc1.png";